import "./Topnav.css";
import "../root.css";

function Topnav() {
  return (
    <div className="nav">
      <header className="nav-header">
        <h3>Game Tracker</h3>
        <a href="#index">Home</a>
      </header>
    </div>
  );
}

export default Topnav;
